<template>
  <transition name="slide">
    <div class="hs-container-child" v-if="show">
      <c-header leftIcon1="return.png" :leftFn1="close" :title="$t('NameFillingInstructions')"></c-header>
      <hs-scroll class="table-view" :data="[details]">
        <!--<ul>
          <div v-html="details"></div>
        </ul>-->
        <iframe class="iframe" width="100%" :src="url" frameborder="0"></iframe>
      </hs-scroll>
    </div>
  </transition>
</template>
<script type="text/ecmascript-6">
// import axios from 'axios'
import CHeader from 'components/c-header/c-header'
import HsScroll from 'base/hs-scroll/hs-scroll'

export default {
  data() {
    return {
      show: false,
      details: '',
      url: ''
    }
  },
  watch: {
    show(val) {
      if (val) {
        this._getDetails()
      }
    }
  },
  methods: {
    open() {
      this.show = true
    },
    close() {
      this.show = false
    },
    /** 获取姓名填写说明 */
    _getDetails() {
      this.url = this.domainNameReplace('https://h5comm.homsom.com/static/html/nameExplain.html')
      // let url = '/static/html/nameExplain.html'
      // axios.get(url).then((res) => {
      //   this.details = res.data
      // })
    }
  },
  components: {
    CHeader,
    HsScroll
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.hs-container-child
  @extend .flex-column
  @extend .flex-start
  position absolute
  width 100%
  height 100%
  left 0
  top 0
  bottom 0
  background-color $color_gray_background_0
  z-index 200
  .table-view
    width 100%
    height calc(100% - 45px)
    overflow hidden
    .iframe
      height calc(100vh - 45px)
</style>
